import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid'; // Pour générer un ID unique
import AxiosConfig from '../../../config/AxiosConfig';
import socketService from '../../helpers/utils/socketService';

const OnlineUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const requestIdRef = useRef(null); // Stocker l'ID unique de la requête en cours
  const usersBufferRef = useRef([]); // Stocker temporairement les utilisateurs reçus

  // Fonction pour récupérer les utilisateurs connectés via HTTP
  const fetchOnlineUsers = () => {
    setLoading(true);
    setUsers([]); // Purge l'ancienne liste
    usersBufferRef.current = []; // Purge les anciennes réponses socket
    requestIdRef.current = uuidv4(); // Génère un nouvel ID unique pour cette requête

    AxiosConfig.create('get', '/users/getConnectedUsers')
      .call()
      .exit((_res) => {})
      .catch((err) => {
        setError('Erreur lors du chargement des utilisateurs connectés');
        setLoading(false);
        console.error(err);
      });
  };

  // Fonction qui fusionne les réponses Socket.IO pour la requête en cours
  const handleSocketUsers = (socketUsers, incomingRequestId) => {
    if (incomingRequestId !== requestIdRef.current) {
      return; // Ignorer les anciennes requêtes
    }

    // Fusionner les utilisateurs reçus sans doublon
    const updatedUsers = [
      ...usersBufferRef.current.filter(
        (existingUser) =>
          !socketUsers.some((newUser) => newUser._id === existingUser._id)
      ),
      ...socketUsers,
    ];

    usersBufferRef.current = updatedUsers;
    setUsers(updatedUsers);
    setLoading(false);
  };

  useEffect(() => {
    fetchOnlineUsers();

    // Écoute des réponses Socket.IO
    socketService.onNotification('connectedUserList', (socketUsers) => {
      handleSocketUsers(socketUsers, requestIdRef.current);
    });

    return () => {
      socketService.offNotification('connectedUserList');
    };
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center">
        {error}
      </Typography>
    );
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}
      >
        Utilisateurs Connectés
      </Typography>
      {users.length === 0 ? (
        <Typography align="center">
          Aucun utilisateur en ligne actuellement.
        </Typography>
      ) : (
        <TableContainer component={Paper} sx={{ height: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>SocketID</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.map((user) => (
                <TableRow key={user?._id} hover>
                  <TableCell>{user?.email}</TableCell>
                  <TableCell>
                    <Typography
                      sx={[
                        {
                          fontWeight: 'bold',
                          color:
                            user?.status === 'active'
                              ? 'green'
                              : user?.status === 'inactive'
                                ? 'orange'
                                : user?.status === 'busy'
                                  ? 'red'
                                  : 'gray',
                        },
                      ]}
                    >
                      {user?.status}
                    </Typography>
                  </TableCell>
                  <TableCell>{user?.socketId}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default OnlineUsers;
